// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import ReactModal from "react-modal";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ClientOnly$PrezzeeRibbon from "../../common/ClientOnly/ClientOnly.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var fadeIn = BsCssJs$PrezzeeRibbon.keyframes([
      [
        0,
        [BsCssJs$PrezzeeRibbon.opacity(0.0)]
      ],
      [
        100,
        [BsCssJs$PrezzeeRibbon.opacity(1.0)]
      ]
    ]);

var fadeUp = BsCssJs$PrezzeeRibbon.keyframes([
      [
        0,
        [
          BsCssJs$PrezzeeRibbon.opacity(0.0),
          BsCssJs$PrezzeeRibbon.transform({
                NAME: "translate",
                VAL: [
                  BsCssJs$PrezzeeRibbon.pct(-50),
                  {
                    NAME: "calc",
                    VAL: [
                      "sub",
                      BsCssJs$PrezzeeRibbon.pct(-50),
                      BsCssJs$PrezzeeRibbon.px(-50)
                    ]
                  }
                ]
              })
        ]
      ],
      [
        100,
        [
          BsCssJs$PrezzeeRibbon.opacity(1.0),
          BsCssJs$PrezzeeRibbon.transform({
                NAME: "translate",
                VAL: [
                  BsCssJs$PrezzeeRibbon.pct(-50),
                  BsCssJs$PrezzeeRibbon.pct(-50)
                ]
              })
        ]
      ]
    ]);

function modalOverlay(isOpen) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.position("fixed"),
              BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.bottom(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.backgroundColor({
                    NAME: "rgba",
                    VAL: [
                      0,
                      0,
                      0,
                      {
                        NAME: "num",
                        VAL: 0.5
                      }
                    ]
                  }),
              BsCssJs$PrezzeeRibbon.animation(Theme__Animation$PrezzeeRibbon.slow, undefined, undefined, "easeOut", undefined, undefined, undefined, fadeIn),
              BsCssJs$PrezzeeRibbon.transition(Theme__Animation$PrezzeeRibbon.slow, undefined, "easeOut", "opacity"),
              BsCssJs$PrezzeeRibbon.opacity(isOpen ? 1 : 0),
              BsCssJs$PrezzeeRibbon.zIndex(9999)
            ]);
}

function modalContainer(isOpen) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.position("absolute"),
              BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
              BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(50)),
              BsCssJs$PrezzeeRibbon.transform({
                    NAME: "translate",
                    VAL: [
                      BsCssJs$PrezzeeRibbon.pct(-50),
                      isOpen ? BsCssJs$PrezzeeRibbon.pct(-50) : ({
                            NAME: "calc",
                            VAL: [
                              "sub",
                              BsCssJs$PrezzeeRibbon.pct(-50),
                              BsCssJs$PrezzeeRibbon.px(-50)
                            ]
                          })
                    ]
                  }),
              BsCssJs$PrezzeeRibbon.animation(Theme__Animation$PrezzeeRibbon.slow, undefined, undefined, "easeOut", undefined, undefined, undefined, fadeUp),
              BsCssJs$PrezzeeRibbon.transition(Theme__Animation$PrezzeeRibbon.slow, undefined, "easeOut", "all"),
              BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.vh(90)),
              BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.vw(80)),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.vw(60))])
            ]);
}

var borderStyle = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.background(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(20)),
      BsCssJs$PrezzeeRibbon.borderRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius)
    ]);

var borderlessStyle = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.background(Theme__Color$PrezzeeRibbon.Personal.darkGrey)]);

var modalContent = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.overflow("auto")]);

var Styles = {
  fadeIn: fadeIn,
  fadeUp: fadeUp,
  modalOverlay: modalOverlay,
  modalContainer: modalContainer,
  borderStyle: borderStyle,
  borderlessStyle: borderlessStyle,
  modalContent: modalContent
};

function Modal__Container(props) {
  var className = props.className;
  var borderless = props.borderless;
  var isOpen = props.isOpen;
  var borderless$1 = borderless !== undefined ? borderless : false;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx(ClientOnly$PrezzeeRibbon.make, {
              children: JsxRuntime.jsx(ReactModal, {
                    isOpen: isOpen,
                    children: JsxRuntime.jsx("div", {
                          children: props.children,
                          className: modalContent
                        }),
                    onAfterOpen: props.onAfterOpen,
                    onAfterClose: props.onAfterClose,
                    onRequestClose: props.onRequestClose,
                    closeTimeoutMS: Theme__Animation$PrezzeeRibbon.slow,
                    contentLabel: props.contentLabel,
                    overlayClassName: modalOverlay(isOpen),
                    className: Classnames([
                          modalContainer(isOpen),
                          borderless$1 ? borderlessStyle : borderStyle,
                          className$1
                        ]),
                    id: props.id
                  })
            });
}

var make = Modal__Container;

export {
  Styles ,
  make ,
}
/* fadeIn Not a pure module */
